import { MembershipOverviewItem, OverviewItemProps } from '../MembershipOverviewItem';
import { useGlobalState } from '../../../state/state';
import { getMemberNumber, ROLE_TYPE_MAP } from '../../../utils/stringHelper';
import { Pages } from '../../../utils/constants';
import { PhoneType } from '@ace-clublabs/common-membership-api-types';

export const MembersOverview = () => {
  const [membershipDetails] = useGlobalState('memberDetails');
  let { members, loggedInMember, loggedInCustomerId } = membershipDetails;
  const canViewMembership = loggedInMember?.rules?.viewMembership;
  if (!canViewMembership) members = members?.filter((member) => member?.customerId === loggedInCustomerId);

  const loggedInMemberMobileNumber = getMemberNumber(loggedInMember!, PhoneType.MOBILE);
  const loggedInMemberHomeNumber = getMemberNumber(loggedInMember!, PhoneType.HOME);

  const membersItems: OverviewItemProps['items'] =
    members?.flatMap((member, i) => {
      const { firstName, middleName, lastName, nameSuffix, spinOffStatus } = member;
      const key = `${member.roleType}-${member.firstName}-${member.lastName}`.toLowerCase();
      const getFormattedName = () => {
        const formattedMiddleInitial = middleName ? `${middleName.charAt(0).toUpperCase()} ` : '';
        const suffix = nameSuffix ? `, ${nameSuffix.toUpperCase()}` : '';
        return `${firstName} ${formattedMiddleInitial}${lastName}${suffix}`;
      };
      return [
        {
          type: 'info',
          title: getFormattedName(),
          subtitle: ROLE_TYPE_MAP[member.roleType],
          isLoggedInMember: member.customerId === loggedInCustomerId,
          email: loggedInMember?.emailAddress,
          mobile: loggedInMemberMobileNumber,
          home: loggedInMemberHomeNumber,
          key,
          spinOffStatus,
          mask: 'title',
        },
      ];
    }) || [];

  membersItems.push({
    type: 'link',
    text: 'View/change member details',
    link: Pages.MembersDetailsPage,
    key: 'members-details-link',
  });

  return (
    <MembershipOverviewItem
      id="members-overview"
      iconName="user-group-duotone"
      overviewText="Members"
      items={membersItems}
    />
  );
};
